/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Out_For_DeliveryInputs */

const tr_geliver_substatus_out_for_delivery = /** @type {(inputs: Geliver_Substatus_Out_For_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dağıtımda`)
};

const en_geliver_substatus_out_for_delivery = /** @type {(inputs: Geliver_Substatus_Out_For_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Out for Delivery`)
};

const de_geliver_substatus_out_for_delivery = /** @type {(inputs: Geliver_Substatus_Out_For_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Zustellung`)
};

const ru_geliver_substatus_out_for_delivery = /** @type {(inputs: Geliver_Substatus_Out_For_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В доставке`)
};

/**
* | output |
* | --- |
* | "Out for Delivery" |
*
* @param {Geliver_Substatus_Out_For_DeliveryInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_out_for_delivery = /** @type {((inputs?: Geliver_Substatus_Out_For_DeliveryInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Out_For_DeliveryInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_out_for_delivery(inputs)
	if (locale === "de") return de_geliver_substatus_out_for_delivery(inputs)
	if (locale === "ru") return ru_geliver_substatus_out_for_delivery(inputs)
	return tr_geliver_substatus_out_for_delivery(inputs)
});